import { AnimatedThemeToggler } from "@/components/ui/animated-theme-toggler";
import { Spinner } from "@/components/ui/spinner";
import { useUser } from "@/lib/auth/session";
import { cn } from "@/lib/utils";
import { ArrowUpRight } from "lucide-react";
import Link from "next/link";
import { SearchDialog } from "../../ui/SearchBox";
import { HamburgerAnimated } from "./HamburgerAnimated";

interface MenuItem {
	label: string;
	description: string;
	component: React.ReactNode;
	requiresAuth: boolean;
}

export default function OptionsMenu({ menu = false }: { menu?: boolean }) {
	const { user, isUserLoading, error } = useUser();

	if (isUserLoading) {
		return <Spinner className="size-3 self-center" />;
	}

	if (error) {
		console.error(error);
	}

	const menuItems: MenuItem[] = [
		{
			label: "Search",
			description: "Search for maps, cities, and communities",
			component: <SearchDialog />,
			requiresAuth: false,
		},
		// {
		// 	label: "Theme",
		// 	description: "Change the theme of the app",
		// 	component: <ThemeSelector />,
		// 	requiresAuth: false,
		// },
		{
			label: "Theme Changer",
			description: "Change the theme of the app",
			component: <AnimatedThemeToggler />,
			requiresAuth: false,
		},
		// {
		// 	label: "Notifications",
		// 	description: "View your notifications",
		// 	component: <NotificationsMenu />,
		// 	requiresAuth: true,
		// },
		// {
		// 	label: "Maps",
		// 	description: "Discover maps",
		// 	component: (
		// 		<Link
		// 			href="/discover"
		// 			className="block rounded-full p-2 transition has-tooltip hover:bg-primary/20"
		// 		>
		// 			<MapIcon className="size-5 fill-primary/40 stroke-primary group-hover:stroke-[2px]" />
		// 			<span className="sr-only ">Maps</span>
		// 			<span className="text-nowrap tooltip tooltip-bottom">Explore Maps</span>
		// 		</Link>
		// 	),
		// },
	];

	return (
		<div className="relative group">
			{menu && (
				<div className="hidden">
					<button
						type="button"
						className={cn(
							"block text-sm font-semibold text-primary-64 transition-all py-2 px-1 mr-1 rounded-full border border-transparent",
							"group-hover:bg-primary/10 group-hover:text-primary group-hover:border-primary-34 group-hover:shadow-inner group-hover:shadow-primary/10",
							"focus:outline-none focus:bg-primary/10 focus:text-primary focus:border-primary-34 focus:shadow-inner focus:shadow-primary/10",
						)}
					>
						<HamburgerAnimated />
						<span className="sr-only">Options</span>
					</button>
				</div>
			)}
			<div
				className={cn(
					"flex flex-row gap-2 top-full items-center justify-center",
					"group-hover:opacity-100 group-hover:visible transition-all duration-200 pointer-events-none group-hover:pointer-events-auto",
				)}
			>
				{menuItems.map((item) => {
					const component = item.component;
					if (item.requiresAuth && !user) return null;
					return (
						<div
							key={item.label}
							className="z-50 rounded-full transition duration-200 ease-in-out"
						>
							<div className="flex items-center justify-center place-content-center">
								{component}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

const ExploreButton = () => {
	return (
		<Link
			href="/discover"
			className="hidden sm:flex items-center gap-0.5 text-xs font-medium text-primary-64 transition-all hover:scale-102 hover:font-bold hover:text-primary cursor-pointer"
		>
			<span className="text-xs text-nowrap">Explore Maps</span>
			<ArrowUpRight className="size-5" />
		</Link>
	);
};
